export type AlertRoleType = 'error' | 'info' | 'success' | 'warning';

export interface ContentType {
  text: string;
  linkText?: string;
}

export interface Alert {
  content: ContentType[];
  icon: boolean;
  role: AlertRoleType;
  title?: string;
  isDisplay: boolean;
  isFocus: boolean;
  id: string;
  code?: string;
}
